<div class="shadow nav-header-container myelement1" id="bpgHeader" *ngIf="loginError">
  <div>
    <ul class="nav nav-header ul-styles">
      <li class="nav-item">
        <a class="nav-link img_anchortag">
          <img src="assets/images/ERGconnect_logo.png" alt="ERG Connect Logo" class="logo-img">
        </a>
      </li>
      <li class="nav-item nav-itemList userdetails-margin">
        <a class="nav-link username_anchortag">
          <span id="userName">Hello {{userFirstName}}</span><br>
          <span id="siteLocn">Site location - {{siteName}}</span>
          <span class="change-style pl-2" *ngIf="isSiteAffected" (click)="manualSiteChange()"><a class="download-link">Change</a></span>
        </a>
      </li>
     <li class="nav-item nav-itemList1">
        <a  href = "mailto:is_service_desk@toyota.com" class="a-cursor-color"><i class="fa fa-envelope"></i> Contact Us</a>
      </li>
      <li class="nav-item nav-itemList1">
        <a (click)="logOut()" class="a-cursor"><i class="fa fa-sign-out logout-icon" aria-hidden="true"></i>Logout</a>
      </li>
     
    </ul>
  </div>

  <div>
    <app-navigation-menu></app-navigation-menu>
  </div>
</div>
